// extracted by mini-css-extract-plugin
export var container = "_6q-0";
export var error = "_6q-9";
export var label = "_6q-5";
export var light = "_6q-6";
export var md = "_6q-3";
export var sm = "_6q-2";
export var thin = "_6q-8";
export var thinBold = "_6q-7";
export var vertical = "_6q-4";
export var xs = "_6q-1";